import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { TechPartsReportItem } from "../../models/reports.model";
import { currencify } from "../../helpers/common";
import { Router } from "@angular/router";
import { ReportsService } from "../../services/reports.service";
import { ViewAsService } from '../../services/view-as.service';

@Component({
  selector: 'app-tech-parts-report-tile',
  templateUrl: './tech-parts-report-tile.component.html',
  styleUrls: ['./tech-parts-report-tile.component.scss']
})
export class TechPartsReportTileComponent implements OnInit {

  protected readonly currencify = currencify;

  @Input() item!: TechPartsReportItem;
  @Input() kind!: 'Pending' | 'Paid';

  @HostBinding('attr.id') id!: string;

  readonly$ = this.viewAsService.readonly$;

  get dividerNeed() {
    const hostElement = this.el.nativeElement;

    if (!hostElement) {
      return false;
    }

    let nextNode = hostElement.nextSibling;

    while (nextNode && (nextNode.nodeType === Node.TEXT_NODE || nextNode.nodeType === Node.COMMENT_NODE)) {
      nextNode = nextNode.nextSibling;
    }

    if (!nextNode) {
      return false;
    }

    return nextNode.nodeName === 'APP-TECH-PARTS-REPORT-TILE';
  }

  get checked() {
    return this.reportsService.selectedTechPartIds.has(this.item.id);
  }

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private viewAsService: ViewAsService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.id = `${this.item.wId}_${this.item.pId}_${this.item.id}`;
  }

  async openPayment(wId: number, pId: number) {
    await this.router.navigate([`/payments/${wId}/${pId}`]);
  }

  check(checked: boolean, itemId: any) {
    if (checked && !this.reportsService.selectedTechPartIds.has(itemId))
      this.reportsService.selectedTechPartIds.add(itemId);

    if (!checked && this.reportsService.selectedTechPartIds.has(itemId))
      this.reportsService.selectedTechPartIds.delete(itemId);
  }
}
